import React from "react";
import styled from "styled-components";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useAppState } from "../../shared/ContextProvider";

const StyledFilterWrapper = styled.div`
  width: 101px;
  height: auto;
  padding: 4px;
  background-color: #fff;
  border: 0.4px solid #939fa5;
  border-radius: 4px;
  margin: 3px 0 0 0;
  position: absolute;
  z-index: 2000;
`;

const StyledFormControlLabel = styled(FormControlLabel)`
  .MuiFormControlLabel-label {
    font-size: 14px;
  }
`;

export function MethodFilterItems() {
  const { state, dispatch } = useAppState();

  console.log("SHELF:", state.shelf);
  console.log("MILLING:", state.milling);

  return (
    <StyledFilterWrapper>
      <FormGroup>
        <StyledFormControlLabel
          value="end"
          control={
            <Checkbox
              checked={state.milling}
              onChange={() => dispatch({ type: "MILLING" })}
              color="primary"
            />
          }
          label={"밀링"}
          labelPlacement="end"
        />
        <StyledFormControlLabel
          value="end"
          control={
            <Checkbox
              checked={state.shelf}
              onChange={() => dispatch({ type: "SHELF" })}
              color="primary"
            />
          }
          label={"선반"}
          labelPlacement="end"
        />
      </FormGroup>
    </StyledFilterWrapper>
  );
}

export function MaterialFilterItems() {
  return (
    <StyledFilterWrapper>
      <FormGroup>
        <StyledFormControlLabel
          value="end"
          control={<Checkbox color="primary" />}
          label={"알루미늄"}
          labelPlacement="end"
        />
        <StyledFormControlLabel
          value="end"
          control={<Checkbox color="primary" />}
          label={"탄소강"}
          labelPlacement="end"
        />
        <StyledFormControlLabel
          value="end"
          control={<Checkbox color="primary" />}
          label={"구리"}
          labelPlacement="end"
        />
        <StyledFormControlLabel
          value="end"
          control={<Checkbox color="primary" />}
          label={"합금강"}
          labelPlacement="end"
        />
        <StyledFormControlLabel
          value="end"
          control={<Checkbox color="primary" />}
          label={"강철"}
          labelPlacement="end"
        />
      </FormGroup>
    </StyledFilterWrapper>
  );
}
